import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DisconnectIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M15.1707 5C15.5825 3.83479 16.6938 3 18 3C19.6568 3 21 4.34309 21 6C21 7.65691 19.6568 9 18 9C16.6938 9 15.5825 8.16521 15.1707 7H7C5.89543 7 5 7.89543 5 9C5 10.1046 5.89543 11 7 11H8C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13H7C4.79086 13 3 11.2091 3 9C3 6.79086 4.79086 5 7 5H15.1707ZM18 5C17.4477 5 17 5.44769 17 6C17 6.55231 17.4477 7 18 7C18.5523 7 19 6.55229 19 6C19 5.44771 18.5523 5 18 5ZM9.52513 9.52513C9.91565 9.1346 10.5488 9.1346 10.9393 9.52513L12 10.5858L13.0607 9.52513C13.4512 9.1346 14.0843 9.1346 14.4749 9.52513C14.8654 9.91565 14.8654 10.5488 14.4749 10.9393L13.4142 12L14.4749 13.0607C14.8654 13.4512 14.8654 14.0843 14.4749 14.4749C14.0843 14.8654 13.4512 14.8654 13.0607 14.4749L12 13.4142L10.9393 14.4749C10.5488 14.8654 9.91565 14.8654 9.52513 14.4749C9.1346 14.0843 9.1346 13.4512 9.52513 13.0607L10.5858 12L9.52513 10.9393C9.1346 10.5488 9.1346 9.91565 9.52513 9.52513ZM15 12C15 11.4477 15.4477 11 16 11H17C19.2091 11 21 12.7909 21 15C21 17.2091 19.2091 19 17 19H8.8293C8.41745 20.1652 7.30618 21 6 21C4.34312 21 3 19.6569 3 18C3 16.3431 4.34312 15 6 15C7.30618 15 8.41745 15.8348 8.8293 17H17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13H16C15.4477 13 15 12.5523 15 12ZM6 17C5.44769 17 5 17.4477 5 18C5 18.5523 5.44769 19 6 19C6.55227 19 7 18.5523 7 18C7 17.4477 6.55227 17 6 17Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

DisconnectIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DisconnectIcon);
